module.exports = __webpack_public_path__ + "img/advertise_lo.ee05038f.jpg";